import { SurplusEntry } from './surplus';

export interface BuyerOrderModel {
  id: string;
  logisticStatus: LogisticStatus;
  paymentStatus: number;
  orderReferenceNumber: string;
  orderReference: string;
  deliveryDate: Date;
  cutOffDate: Date;
  fulfilmentDate: Date;
  createdOn: Date;
  isLocked: boolean;
  products: BuyerOrderProductModel[];
  orderedByUserId: string;
  orderedByUserEmail: string;
  orderedByUserName: string;
  orderedBySiteId: string;
  distributorName: string;
  hasIssue?: boolean;
}
export interface BuyerOrderProductModel {
  id: string;
  price: number;
  requestedQuantity: number;
  confirmedQuantity: number;
  productName: string;
  productStockId: string;
  estimatedWeight?: number | null;
  receivedWeight?: number | null;
  hasIssue?: boolean;
  surplusEntry?: SurplusEntry;
  units: string;
}

export enum LogisticStatus {
  OrderReceived = '1',
  Edited = '2',
  Picking = '3',
  Packed = '4',
  Loaded = '5',
  OutForDelivery = '6',
  Delivered = '7',
  PartiallyDelivered = '8',
  CouldNotBeDelivered = '9',
  Cancelled = '10',
}

export const LogisticStatusLabels: { [key in LogisticStatus]: string } = {
  [LogisticStatus.OrderReceived]: 'Order Received',
  [LogisticStatus.Edited]: 'Edited',
  [LogisticStatus.Picking]: 'Picking',
  [LogisticStatus.Packed]: 'Packed',
  [LogisticStatus.Loaded]: 'Loaded',
  [LogisticStatus.OutForDelivery]: 'Out For Delivery',
  [LogisticStatus.Delivered]: 'Delivered',
  [LogisticStatus.PartiallyDelivered]: 'Partially Delivered',
  [LogisticStatus.CouldNotBeDelivered]: 'Could Not Be Delivered',
  [LogisticStatus.Cancelled]: 'Cancelled',
};

export const isDelivered = (status: LogisticStatus) =>
  status === LogisticStatus.Delivered || status === LogisticStatus.PartiallyDelivered;

export interface OrderIssueModel {
  issueId: string;
  orderId: string;
  orderReferenceNumber: string;
  orderReference: string | null;
  logisticStatus: LogisticStatus;
  deliveryDate: Date;
  createdOn: Date;
  buyerOrderProductId?: string;
  productStockId?: string;
  issueType: string; // should be formatted as number
  resolutionType: string; // should be formatted as number
  details: string;
  productName?: string;
  units?: string;
  distributorReference?: string;
  reasonForChange?: OrderProductReasonForChange | null;
  substitutionProductStockId?: string | null;
  substitutionProductPriceId?: string | null;
  substitutionProductName?: string | null;
  substitutionProductUnits?: string | null;
  substitutionProductPrice?: number | null;
  substitutionProductQuantity?: number | null;
  replies: OrderIssueReplyModel[];
  images?: string[];
}

export enum OrderIssueReplyCreatedBy {
  BUYER,
  DISTRIBUTOR,
}

export interface OrderIssueReplyModel {
  id: string;
  createdByUserName: string | null;
  createdByEntity: OrderIssueReplyCreatedBy;
  createdOn: string;
  reconciled: boolean;
  details: string;
  createdByEmail: boolean;
  images?: string[];
}

export interface OrderIssueLogModel extends OrderIssueModel {
  lastModifiedOn: string | null;
  lastModifiedBy: string | null;
  reportedByName: string;
  distributorName?: string;
  replies: OrderIssueReplyModel[];
}

export interface SubstitutionInfo {
  productStockId?: string | null;
  productPriceId?: string | null;
  productName?: string | null;
  units?: string;
  productPrice?: number | null;
  productQuantity?: number;
  reasonForChange?: OrderProductReasonForChange | null;
}

export interface CreateOrderIssueRequestModel {
  buyerOrderProductId?: string;
  issueType: OrderIssueType | ProductIssueType;
  resolutionType: OrderIssueResolutionType;
  details?: string;
  substitutionInfo?: SubstitutionInfo | null;
  images?: string[];
}

export interface UpdateOrderIssueRequestModel {
  issueType: number;
  resolutionType: number;
  details: string;
}

export interface CreateOrderIssueReplyModel {
  reconciled: boolean;
  details: string;
  images?: string[];
}

export interface UploadOrderIssueImageResponse {
  result: string;
}

export enum ProductIssueType {
  Quantity = 0,
  Quality,
  'Different Product',
  'Shelf Life',
  Packaging,
  Specification,
  Temperature,
  Feedback,
}

export enum OrderIssueType {
  'Delivery Date' = 8,
  'Delivery Temperature',
  'Delivery Note',
  'Delivery Unstable',
  'Delivery Vehicle',
  'Delivery Feedback',
}

export enum ProductIssueResolutionType {
  'Refund' = 1,
  'Replace',
  'No Action',
}

export enum OrderIssueResolutionType {
  'No Action' = 3,
  'Call Back',
  'Reissue Document',
}

export enum OrderProductReasonForChange {
  'Substitution' = 1,
  'Distributor Error',
  'Unknown',
}
